import { html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { CSCDeliveryMatchMethods } from 'components/ordering/delivery-match/delivery-match-methods.js'

import { style } from './delivery-match.style.js'
import { CSCDeliveryMatchDeliveryMethodSelector } from './delivery-match-delivery-method-selector.js'
import { CSCDeliveryMatchDropoffMethodSelector } from './delivery-match-dropoff-method-selector.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { consume } from '@lit/context'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { DeliveryMatchErrorContext, DeliveryMatchSelectedMethodGroupContext, type DeliveryMatchErrorContextType, type DeliveryMatchSelectedMethodGroupContextType } from './provider.js'
import { DEFAULT_VISIBLE_METHODS_ON_INIT } from './visible-methods-on-init.js'

initializeIconsByRole({
  'csc-delivery-match.list': { name: 'list', style: 'light' },
  'csc-delivery-match.map': { name: 'map', style: 'light' },
  'csc-delivery-match.dropoff-method-distance': { name: 'location-arrow', style: 'light' }
})

@customElement('delivery-match-root-error')
class DeliveryMatchRootError extends LitElement {
  @consume({ context: DeliveryMatchErrorContext, subscribe: true })
  private error!: DeliveryMatchErrorContextType

  override render() {
    if (this.error === null) return nothing
    if (this.error.level == 'root') return nothing
    if (this.error.level == 'search') return nothing

    return html`
      <cse-alert variant=${this.error.severity}>
        ${this.error.title}
        ${this.error.description !== null ? html`
        <span slot="description">
          ${this.error.description}
        </span>` : nothing}
      </cse-alert>
    `
  }
}

@customElement('csc-delivery-match')
export class CSCDeliveryMatch extends LitElement {
  @consume({ context: DeliveryMatchSelectedMethodGroupContext, subscribe: true })
  private selectedMethodGroup!: DeliveryMatchSelectedMethodGroupContextType

  @property({ type: Boolean, attribute: 'show-radio-buttons-group', reflect: true })
  showRadioButtonsGroup: boolean = false

  @property({ type: Boolean, attribute: 'show-icons-group', reflect: true })
  showIconsGroup: boolean = false

  @property({ type: Boolean, attribute: 'inline-groups', reflect: true })
  inlineGroups: boolean = false

  @property({ type: Boolean, attribute: 'show-radio-buttons-methods', reflect: true })
  showRadioButtonsMethods: boolean = false

  @property({ type: Number, attribute: 'visible-methods-on-init', reflect: true })
  visibleMethodsOnInit: number = DEFAULT_VISIBLE_METHODS_ON_INIT

  static override styles = [hostStyle, style]

  private get visibleMethods() {
    if (!Number.isFinite(this.visibleMethodsOnInit)) return DEFAULT_VISIBLE_METHODS_ON_INIT
    if (this.visibleMethodsOnInit < 1) return DEFAULT_VISIBLE_METHODS_ON_INIT

    return this.visibleMethodsOnInit
  }

  override render() {
    return html`
      <div class="delivery-match-container">
        ${new CSCDeliveryMatchMethods({
          showRadioButtonsGroup: this.showRadioButtonsGroup,
          showIconsGroup: this.showIconsGroup,
          inline: this.inlineGroups
        })}
        ${this.selectedMethodGroup == 'delivery'
        ? new CSCDeliveryMatchDeliveryMethodSelector({
          showRadioButtonsMethods: this.showRadioButtonsMethods,
          visibleMethodsOnInit: this.visibleMethods
        })
        : nothing}
        ${this.selectedMethodGroup == 'dropoff'
        ? new CSCDeliveryMatchDropoffMethodSelector({
          showRadioButtonsMethods: this.showRadioButtonsMethods,
          visibleMethodsOnInit: this.visibleMethods
        })
        : nothing}
        ${new DeliveryMatchRootError()}
    </div>`
  }
}
